import { Box, Typography, Button } from "@mui/material";
import Grid from "@mui/material/Grid";
import React, { useEffect, useState } from "react";
import BreadCrumb from "../components/BreadCrumb";
import JobDetailsCard from "../components/JobDetailsCard";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import JobCard from "../components/JobCards";
import API from "../api";
import SubscribeComponent from "../components/SubscribeComponent";
import ApplyModal from "../components/ApplyModal";
import logo from "../assets/browse-job/logo.png";
import CustomAvatarGroup from "../components/CustomAvatarGroup";
import ShareButton from "../components/ShareModal";

const JobDetails = () => {
  const loc = useLocation();
  const [data, setData] = useState(loc?.state || []);
  const param = useParams();
  const navigate = useNavigate();
  const [open, setOpen] = useState(null);
  const [relatedJobs, setRelatedJobs] = useState([]);
  const [showStickyApply, setShowStickyApply] = useState(false);

  const breadcrumbItems = [
    { text: "Home", href: "/Shglocums/browse-jobs/" },
    { text: "Browse jobs", href: `/Shglocums/browse-jobs/` },
    { text: "Job details", href: `/` },
  ];

  const getJobsHandler = async () => {
    try {
      const resp = await API.get(`/api/get-related-jobs/${param?.id}`);
      if (resp?.data?.success) {
        setRelatedJobs(resp?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getJobDetailsHandler = async () => {
    try {
      const resp = await API.get(`/api/get-posted-job-detail/${param?.id}`);
      if (resp?.data?.success) {
        setData(resp?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getJobDetailsHandler();
    getJobsHandler();
    scrollToTop();
  }, [param?.id]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setShowStickyApply(scrollPosition > 200);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const handleViewClick = (job) => {
    localStorage.setItem("job-details", JSON.stringify(job));
    scrollToTop();
    navigate(`/Shglocums/browse-jobs/job-details/${job?.id}`, {
      state: job,
    });
  };

  const handleApplyClick = (id) => {
    setOpen(id);
  };

  const closeHandler = () => {
    setOpen(null);
  };

  const addDummyApplicants = (name) => {
    if (data) {
      const newApplicants = [
        {
          id: 16,
          job_id: 1,
          name: name,
          email: "dummy1@gmail.com",
          phone_number: "+92369800001",
        },
      ];

      setData((prevState) => ({
        ...prevState,
        applicants: [...prevState.applicants, ...newApplicants],
      }));
    }
  };
  const formatTimeToAMPM = (timeString) => {
    const date = new Date(`1970-01-01T${timeString}Z`); // Convert time to a date object
    return date.toLocaleString("en-US", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
  };
  const formattedStartTime = formatTimeToAMPM(data?.shift_start_time);
  const formattedEndTime = formatTimeToAMPM(data?.shift_end_time);

  return (
    <Box
      className={"wordpress_main_container"}
      sx={{
        bgcolor: "#ffff",
      }}
    >
      <ApplyModal
        open={open}
        closeHandler={closeHandler}
        addDummyApplicants={addDummyApplicants}
      />

      {/* Header Section */}
      <Box
        sx={{
          mx: "auto",
          width: "100%",
          bgcolor: "#21404B",
          position: "relative",
          p: { xs: "30px 16px 60px 16px", md: "50px 30px 102px 30px" },
        }}
      >
        <Box
          sx={{
            px: { xs: "8px", md: "20px" },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            pb: { xs: "24px", md: "34px" },
          }}
        >
          <BreadCrumb items={breadcrumbItems} textColor="white" />
          <Typography
            variant="h1"
            sx={{
              color: "white",
              fontSize: { xs: "24px", sm: "32px", md: "48px", xl: "60px" },
              fontWeight: 400,
              lineHeight: { xs: "32px", sm: "40px", md: "56px", xl: "70px" },
              fontFamily: "DM Serif Text",
              letterSpacing: "0px",
              textTransform: "capitalize",
              textAlign: { xs: "center", md: "left" },
            }}
          >
            {data?.title}
          </Typography>
        </Box>

        {/* Apply Section */}
        <Box
          sx={{
            maxWidth: { xs: "100%", sm: "80%", md: "97%", xl: "1620px" },
            mx: "auto",
            bgcolor: "white",
            borderRadius: { xs: "16px", md: "24px" },
            p: { xs: "20px", sm: "24px", md: "32px" },
          }}
        >
          <Grid container spacing={{ xs: 2, md: 0 }}>
            {/* Company Logo/Icon */}
            <Grid item xs={12} sm={3} md={2}>
              <Box
                sx={{
                  width: { xs: "80px", sm: "100px", md: "134px" },
                  height: { xs: "80px", sm: "100px", md: "134px" },
                  bgcolor: "#2F4F4F",
                  borderRadius: { xs: "12px", md: "16px" },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: { xs: 2, md: 2 },
                  mx: { xs: "auto", sm: "0" },
                }}
              >
                <Box
                  component={"img"}
                  src={logo}
                  alt="company logo"
                  sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              </Box>
            </Grid>

            {/* Job Details */}
            <Grid item xs={12} sm={9} md={10}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", lg: "row" },
                  justifyContent: "space-between",
                  alignItems: { xs: "center", sm: "flex-start", lg: "center" },
                  gap: { xs: 2, lg: 2 },
                  height: "100%",
                  textAlign: { xs: "center", sm: "left" },
                }}
              >
                {/* Left side - Job Info */}
                <Box sx={{ flex: 1 }}>
                  <Typography
                    variant="h4"
                    sx={{
                      fontWeight: 400,
                      fontSize: { xs: "20px", sm: "24px", md: "32px" },
                      lineHeight: { xs: "28px", sm: "32px", md: "40px" },
                      fontFamily: "DM Serif Text",
                      textTransform: "capitalize",
                      color: "#2F4F4F",
                      mb: 1,
                    }}
                  >
                    {data?.title}
                  </Typography>

                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: { xs: "14px", sm: "16px", xl: "18px" },
                      color: "#8B4513",
                      mb: 1,
                    }}
                  >
                    {data?.client?.name}
                  </Typography>

                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: { xs: "12px", sm: "14px", xl: "16px" },
                      color: "#2F4F4F",
                      mb: 1,
                    }}
                  >
                    Type of Job : Locums
                  </Typography>

                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: { xs: "12px", sm: "14px", xl: "16px" },
                      color: "#2F4F4F",
                    }}
                  >
                    Full time : {formattedStartTime} to {formattedEndTime}
                  </Typography>
                </Box>

                {/* Right side - Applicants and Actions */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: {
                      xs: "center",
                      sm: "flex-start",
                      lg: "flex-end",
                    },
                    gap: 2,
                    width: { xs: "100%", sm: "auto" },
                  }}
                >
                  {/* Applicants */}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: {
                        xs: "center",
                        sm: "flex-start",
                        lg: "flex-end",
                      },
                      gap: 1,
                    }}
                  >
                    <CustomAvatarGroup data={data} />
                    <Typography
                      sx={{
                        fontSize: { xs: "12px", sm: "14px", xl: "16px" },
                        fontWeight: 500,
                        color: "#999999",
                      }}
                    >
                      {data?.applicants?.length || 48}+ Applicant
                    </Typography>
                  </Box>

                  {/* Action Buttons */}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", sm: "row" },
                      gap: 2,
                      width: { xs: "100%", sm: "auto" },
                    }}
                  >
                    <Button
                      onClick={() => handleApplyClick(data?.id)}
                      variant="contained"
                      sx={{
                        backgroundColor: "#21404B",
                        color: "white",
                        fontWeight: 500,
                        fontSize: { xs: "16px", md: "18px" },
                        width: { xs: "100%", sm: "200px", md: "250px" },
                        height: { xs: "48px", md: "56px" },
                        p: { xs: "12px 24px", md: "16px 32px" },
                        fontFamily: "'Montserrat', sans-serif",
                        borderRadius: "1000px",
                        textTransform: "none",
                        boxShadow: "none",
                        "&:hover": {
                          backgroundColor: "#1F2937",
                          boxShadow: "none",
                        },
                      }}
                    >
                      Apply now
                    </Button>
                    <ShareButton width={"150px"} />
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>

      {/* Sticky Apply Section */}
      {showStickyApply && (
        <Box
          sx={{
            position: "fixed",
            top: "0px",
            left: "0%",
            width: "100%",
            bgcolor: "white",
            p: { xs: "16px", md: "32px" },
            zIndex: 1000,
            boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          }}
        >
          <Grid container spacing={{ xs: 2, sm: 1 }}>
            {/* Company Logo/Icon */}
            <Grid item xs={12} sm={3} md={2}>
              <Box
                sx={{
                  width: { xs: "60px", sm: "120px", md: "150px" },
                  height: { xs: "60px", sm: "120px", md: "150px" },
                  bgcolor: "#2F4F4F",
                  borderRadius: { xs: "12px", md: "16px" },
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  mb: { xs: 1, md: 2 },
                  mx: { xs: "auto", sm: "0" },
                }}
              >
                <Box
                  component={"img"}
                  src={logo}
                  alt="company logo"
                  sx={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
              </Box>
            </Grid>

            {/* Job Details */}
            <Grid item xs={12} sm={9} md={10}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", lg: "row" },
                  justifyContent: "space-between",
                  alignItems: { xs: "center", sm: "flex-start", lg: "center" },
                  gap: { xs: 2, lg: 2 },
                  height: "100%",
                  textAlign: { xs: "center", sm: "left" },
                }}
              >
                {/* Left side - Job Info */}
                <Box sx={{ flex: 1 }}>
                  <Typography
                    variant="h4"
                    sx={{
                      fontWeight: 400,
                      fontSize: { xs: "18px", sm: "24px", md: "32px" },
                      lineHeight: { xs: "24px", sm: "32px", md: "40px" },
                      fontFamily: "DM Serif Text",
                      textTransform: "capitalize",
                      color: "#2F4F4F",
                      mb: { xs: 0.5, md: 1 },
                    }}
                  >
                    {data?.title}
                  </Typography>

                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: { xs: "12px", sm: "16px", xl: "18px" },
                      color: "#8B4513",
                      mb: { xs: 0.5, md: 1 },
                    }}
                  >
                    {data?.client?.name}
                  </Typography>

                  <Typography
                    sx={{
                      fontWeight: 600,
                      fontSize: { xs: "11px", sm: "14px", xl: "16px" },
                      color: "#2F4F4F",
                      mb: { xs: 0.5, md: 1 },
                    }}
                  >
                    Type of Job : Locums
                  </Typography>

                  <Typography
                    sx={{
                      fontWeight: 500,
                      fontSize: { xs: "11px", sm: "14px", xl: "16px" },
                      color: "#2F4F4F",
                    }}
                  >
                    Full time : {formattedStartTime} to {formattedEndTime}
                  </Typography>
                </Box>

                {/* Right side - Applicants and Actions */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: {
                      xs: "center",
                      sm: "flex-start",
                      lg: "flex-end",
                    },
                    gap: { xs: 1, md: 2 },
                    width: { xs: "100%", sm: "auto" },
                  }}
                >
                  {/* Applicants */}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: {
                        xs: "center",
                        sm: "flex-start",
                        lg: "flex-end",
                      },
                      gap: { xs: 0.5, md: 1 },
                    }}
                  >
                    <CustomAvatarGroup data={data} />
                    <Typography
                      sx={{
                        fontSize: { xs: "11px", sm: "14px", xl: "16px" },
                        fontWeight: 500,
                        color: "#999999",
                      }}
                    >
                      {data?.applicants?.length || 48}+ Applicant
                    </Typography>
                  </Box>

                  {/* Action Buttons */}
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", sm: "row" },
                      gap: { xs: 1, md: 2 },
                      width: { xs: "100%", sm: "auto" },
                    }}
                  >
                    <Button
                      onClick={() => handleApplyClick(data?.id)}
                      variant="contained"
                      sx={{
                        backgroundColor: "#21404B",
                        color: "white",
                        fontWeight: 500,
                        fontSize: { xs: "14px", md: "18px" },
                        width: { xs: "100%", sm: "180px", md: "250px" },
                        height: { xs: "40px", md: "56px" },
                        p: { xs: "10px 20px", md: "16px 32px" },
                        fontFamily: "'Montserrat', sans-serif",
                        borderRadius: "1000px",
                        textTransform: "none",
                        boxShadow: "none",
                        "&:hover": {
                          backgroundColor: "#1F2937",
                          boxShadow: "none",
                        },
                      }}
                    >
                      Apply now
                    </Button>
                    <ShareButton width={"150px"} />
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Box>
      )}

      <Box sx={{ width: "100%", position: "relative", zIndex: 10 }}>
        <JobDetailsCard data={data} handleApplyClick={handleApplyClick} />

        {/* Related Jobs Section */}
        {relatedJobs?.filter((job) => job.id != data?.id)?.length > 0 && (
          <Box
            sx={{
              bgcolor: "#2F4F4F",
              minHeight: { xs: "200px", sm: "300px", md: "400px" },
              display: "flex",
              justifyContent: "center",
              p: { xs: "50px 16px", md: "100px 0px" },
              width: "100%",
              mx: "auto",
            }}
          >
            <Box
              sx={{
                width: "100%",
                maxWidth: "1620px",
                mx: "auto",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  color: "white",
                  fontSize: { xs: "20px", sm: "28px", md: "40px", xl: "60px" },
                  fontWeight: 400,
                  fontFamily: "DM Serif Text",
                  lineHeight: {
                    xs: "28px",
                    sm: "36px",
                    md: "50px",
                    xl: "82.26px",
                  },
                  pl: { xs: "8px", md: "20px" },
                  textAlign: { xs: "center", md: "left" },
                }}
              >
                Related Jobs
              </Typography>

              <Grid
                container
                rowSpacing={{ xs: 2, sm: 2, md: 2 }}
                columnSpacing={2}
                sx={{
                  mt: { xs: 1, sm: 2, md: 3 },
                  display: "flex",
                  justifyContent: { xs: "center", md: "left" },
                  pr: { xs: "8px", md: "15px" },
                  flexWrap: "wrap",
                  width: { xs: "100%", xl: "1620px !important" },
                  mx: "auto",
                }}
              >
                {relatedJobs?.length > 0
                  ? relatedJobs?.map((job, index) => {
                      return (
                        job.id != data?.id && (
                          <Grid item xs={12} sm={6} md={4} xl={3} key={index}>
                            <JobCard
                              recommended={job?.title}
                              title={job?.title}
                              company={job?.client?.name}
                              pay={job?.regular_hourly_rate}
                              jobType={job?.jobType}
                              role={job?.role?.name}
                              speciality={job?.speciality?.name}
                              applicants={job?.applicants}
                              onApplyClick={() => handleApplyClick(job.id)}
                              onViewClick={() => handleViewClick(job)}
                              jobId={job?.id}
                            />
                          </Grid>
                        )
                      );
                    })
                  : null}
              </Grid>
            </Box>
          </Box>
        )}
      </Box>
      <SubscribeComponent />
      <Box sx={{ minHeight: { xs: "0.5rem", md: "1rem" } }}></Box>
    </Box>
  );
};

export default JobDetails;
